var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWatchVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9806 11.1318L10.9961 8.85494C10.3295 8.47399 9.5 8.95536 9.5 9.72318V14.2768C9.5 15.0446 10.3295 15.526 10.9961 15.1451L14.9806 12.8682C15.6524 12.4843 15.6524 11.5157 14.9806 11.1318Z",
    stroke: "#388AF7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.20577C5.60906 5.29751 4.17948 7.03945 3.47763 9.10704C2.77577 11.1746 2.8495 13.4269 3.68508 15.4441C4.52066 17.4614 6.0611 19.1061 8.0194 20.0719C9.9777 21.0376 12.2203 21.2585 14.3294 20.6933C16.4384 20.1282 18.2702 18.8156 19.4832 17.0001C20.6963 15.1846 21.208 12.9901 20.923 10.8253C20.638 8.66047 19.5757 6.67311 17.9341 5.23344C16.2925 3.79378 14.1835 3 12 3",
    stroke: "#388AF7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchVideoIcon);
export default __webpack_public_path__ + "static/media/WatchVideoIcon.e5612cdbfb05a747b09ee0c493ea3197.svg";
export { ForwardRef as ReactComponent };